var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-wrapper"},[(_vm.step == 1)?_c('Step1',{attrs:{"form":_vm.form},on:{"continue":function($event){_vm.step = 2}}}):(_vm.step == 2)?_c('Step2',{attrs:{"form":_vm.form,"countries":_vm.countries},on:{"back":function($event){_vm.step = 1},"submit":_vm.submit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }